import React from 'react';
import '../styles/StatsCard.css';

const StatsCard = ({ title, value, icon, color, subtitle, trend }) => {
    return (
        <div className="stats-card" style={{ borderColor: color }}>
            <div className="stats-icon" style={{ backgroundColor: `${color}20`, color }}>
                {icon}
            </div>
            <div className="stats-content">
                <h3 className="stats-title">{title}</h3>
                <p className="stats-value">{value?.toLocaleString() || 0}</p>
                {subtitle && <span className="stats-subtitle">{subtitle}</span>}
                {trend !== undefined && (
                    <span className={`stats-trend ${trend >= 0 ? 'positive' : 'negative'}`}>
                        {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}%
                    </span>
                )}
            </div>
        </div>
    );
};

export default StatsCard;
